/**
 * Map poll outcomes to ValidationAlert messages (shared by Data Uploader & Sheet Generator).
 */
import { formatCeleryTaskResultForAlert } from "./formatCeleryTaskResultForAlert";

/** Headline + optional detail block, separated by a blank line. */
function joinAlertSections(...parts) {
  return parts.filter((p) => p != null && String(p).trim() !== "").join("\n\n");
}

/**
 * Shows one alert based on `pollCeleryTaskUntilTerminal` outcome. No-op when `aborted`
 * (user left the page or started a new poll — do not update UI after unmount).
 *
 * @param {(severity: string, message: string) => void} showAlert
 * @param {string} outcome
 * @param {unknown} result
 * @param {{
 *   success: { severity: string; headline: string };
 *   failed: { severity: string; headline: string };
 *   timeout: { severity: string; message: string };
 *   fallback: { severity: string; message: string };
 * }} copy
 */
export function applyCeleryPollOutcomeToAlert(showAlert, outcome, result, copy) {
  if (outcome === "aborted") {
    return;
  }
  console.log(outcome, result);

  const detail = formatCeleryTaskResultForAlert(result);

  if (outcome === "completed") {
    showAlert(copy.success.severity, joinAlertSections(copy.success.headline, detail));
    return;
  }
  if (outcome === "failed") {
    showAlert(copy.failed.severity, joinAlertSections(copy.failed.headline, detail));
    return;
  }
  if (outcome === "timeout") {
    showAlert(copy.timeout.severity, copy.timeout.message);
    return;
  }
  showAlert(copy.fallback.severity, copy.fallback.message);
}
